<div class="configuration-selection-container">
  <form [formGroup]="configurationSelect">
    <ng-select
      [ngClass]="{'error-select': form.selectedConfiguration.invalid && submitted}"
      notFoundText="{{ 'view_translations.no_data' | translate }}"
      [searchable]="false"
      placeholder="{{ 'view_translations.select_label' | translate }}"
      class="select-menu"
      formControlName="selectedConfiguration"
      (open)="changeChevronUp()"
      (close)="changeChevronDown()"
      dropdownPosition="bottom"
      (change)="getValue($event)">
      <ng-option *ngFor="let config of configurationsList" [value]="config">
        <span *ngIf="config.number; else ppiConfig">
          {{ config.number + ' ' + ( 'view_translations.internal_shortcut' | translate ) + ' ' + config.number_internal}}
        </span>
        <ng-template #ppiConfig> <ng-container *ngFor="let item of config | keyvalue">{{item.value}} {{item.key }}</ng-container></ng-template>
      </ng-option>
    </ng-select>
    <span class="error-icon" *ngIf="form.selectedConfiguration.touched && form.selectedConfiguration.invalid && submitted">
      <nb-icon icon="cross-circle" pack="icomoon"></nb-icon>
    </span>
  </form>
</div>

<div class="error-message" *ngIf="form.selectedConfiguration.touched && form.selectedConfiguration.value === null && submitted">
  <p>{{ 'view_translations.required_field' | translate }}</p>
</div>
